'use client';

import { c as _c } from "react/compiler-runtime";
import { Header as HeaderSparky, LayoutContainer } from '@petsmart-ui/sparky';
import type { Entry } from 'contentful';
import type { PropsWithChildren } from 'react';
import { LegacyIcon, LegacyIconName } from '@libs/common-next';
import { NAVIGATION_URLS } from '@libs/core';
import { buildPage, ComponentResolver } from '../../utils';
import { Autocomplete } from '../autocomplete';
import { LegacyAccountDropdown } from '../LegacyAccountDropdown';
import { LegacyHeaderDrawer } from '../LegacyHeaderDrawer';
import { LegacyMinicart } from '../LegacyMinicart';
import { LegacyNavAdoptions } from '../LegacyNavAdoptions';
import { LogoWrapper } from '../LogoWrapper';
import LegacyHeaderPersonIcon from './LegacyHeaderPersonIcon';
import type { LegacyHeaderProps } from './types';
import './LegacyHeader.scss';
export default function LegacyHeader(t0) {
  const $ = _c(32);
  const {
    entry,
    children,
    isOptexSearchBiaGuestEnabled: t1
  } = t0;
  const isOptexSearchBiaGuestEnabled = t1 === undefined ? false : t1;
  let t2;
  if ($[0] !== entry?.fields) {
    t2 = entry?.fields ?? {};
    $[0] = entry?.fields;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const {
    mainMenu,
    items,
    livesSaved,
    secondaryNavigation
  } = t2;
  let t3;
  if ($[2] !== items) {
    t3 = items ? buildPage(items as Entry[]) : null;
    $[2] = items;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const entries = t3;
  const t4 = secondaryNavigation as Entry;
  const t5 = livesSaved as Entry;
  let t6;
  if ($[4] !== t4 || $[5] !== t5) {
    t6 = <HeaderSparky.Top className="legacy-header__section legacy-header__section--divide"><LayoutContainer className="legacy-header__container"><LegacyNavAdoptions secondaryNavigation={t4} livesSaved={t5} /></LayoutContainer></HeaderSparky.Top>;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = secondaryNavigation as Entry;
  const t8 = mainMenu as Entry;
  let t9;
  if ($[7] !== t7 || $[8] !== t8) {
    t9 = <LegacyHeaderDrawer secondaryNavigation={t7} mainMenu={t8} />;
    $[7] = t7;
    $[8] = t8;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="legacy-header__logo"><LogoWrapper /></div>;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== isOptexSearchBiaGuestEnabled) {
    t11 = <Autocomplete className="legacy-autocomplete" productsHitPerPage={2} isOptexSearchBiaGuestEnabled={isOptexSearchBiaGuestEnabled} />;
    $[11] = isOptexSearchBiaGuestEnabled;
    $[12] = t11;
  } else {
    t11 = $[12];
  }
  let t12;
  if ($[13] !== children) {
    t12 = <div className="ai-assist">{children}</div>;
    $[13] = children;
    $[14] = t12;
  } else {
    t12 = $[14];
  }
  let t13;
  if ($[15] !== t11 || $[16] !== t12) {
    t13 = <div className="legacy-header__search">{t11}{t12}</div>;
    $[15] = t11;
    $[16] = t12;
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="legacy-header__account"><LegacyAccountDropdown /><LegacyHeaderPersonIcon /></div>;
    $[18] = t14;
  } else {
    t14 = $[18];
  }
  let t15;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <div className="legacy-header__cart"><a href={NAVIGATION_URLS.legacy.storeLocator.base} title="Locate Stores" className="legacy-header__cart-pin-icon"><LegacyIcon aria-hidden="true" name={LegacyIconName.PIN} isPriority={true} size={24} /></a><LegacyMinicart /></div>;
    $[19] = t15;
  } else {
    t15 = $[19];
  }
  let t16;
  if ($[20] !== t13 || $[21] !== t9) {
    t16 = <HeaderSparky.Middle className="legacy-header__section legacy-header__section" hideMenuButton={true}><LayoutContainer className="legacy-header__container" role="banner"><div className="legacy-header__banner--desktop">{t9}{t10}{t13}{t14}{t15}</div></LayoutContainer></HeaderSparky.Middle>;
    $[20] = t13;
    $[21] = t9;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  const t17 = mainMenu as Entry;
  let t18;
  if ($[23] !== t17) {
    t18 = <HeaderSparky.Bottom className="legacy-header__section legacy-header__section--primary" data-testid="legacy-mainmenu"><LayoutContainer className="legacy-header__container"><ComponentResolver entry={t17} /></LayoutContainer></HeaderSparky.Bottom>;
    $[23] = t17;
    $[24] = t18;
  } else {
    t18 = $[24];
  }
  let t19;
  if ($[25] !== t16 || $[26] !== t18 || $[27] !== t6) {
    t19 = <HeaderSparky className="legacy-header" data-testid="legacy-header">{t6}{t16}{t18}</HeaderSparky>;
    $[25] = t16;
    $[26] = t18;
    $[27] = t6;
    $[28] = t19;
  } else {
    t19 = $[28];
  }
  let t20;
  if ($[29] !== entries || $[30] !== t19) {
    t20 = <>{entries}{t19}</>;
    $[29] = entries;
    $[30] = t19;
    $[31] = t20;
  } else {
    t20 = $[31];
  }
  return t20;
}